export const PEP_AI_PROVIDERS = [
  { value: 'openai', label: 'OpenAI' },
  { value: 'gemini', label: 'Gemini' },
  { value: 'gemini_simple', label: 'Gemini-Simple' },
];

export function pepAiProvider(value) {
  return PEP_AI_PROVIDERS.some(option => option.value === value) ? value : 'openai';
}

export function pepAiProviderDescription(value) {
  if (value === 'gemini_simple') return 'Gemini-Simple uses Google Search to discover PEP candidates, followed by a separate identity lookup.';
  if (value === 'gemini') return 'Gemini with Google Search will be used for new PEP public-web searches.';
  return 'OpenAI will be used for new PEP public-web searches.';
}
